<template lang="pug">
  .container
    .single-job
      job-item(:job="job" :readmore="false")
      .row
        .col-md-10.offset-md-2
          .single-job-content(v-html="job.content")
</template>

<script>
import MoveTo from 'moveTo'
import axios from 'axios'
import JobItem from '../components/JobItem.vue'
// import IconAccount from '../../icons/Account2.vue'
export default {
  components: { JobItem },
  data: () => ({
    isLoading: false,
    job: {},
  }),

  mounted() {
    this.fetchData()

    const moveTo = new MoveTo({
      tolerance: 80,
      duration: 800,
    })
    moveTo.move(document.querySelector('.app-header'))
  },

  methods: {
    fetchData(loadMore = false) {
      this.isLoading = true
      axios
        .get(`${THAIRUNG.api_endpoint}thairung/job/single`, {
          params: { slug: this.$route.params.slug, lang: '' }
        })
        .then(({ data }) => {
          this.job = data.data 
          this.meta = data.meta
        })
        .catch(error => {
        })
        .then(()=> {
          this.isLoading = false
        })
    }
  }
}
</script>